<template>
  <div class="item-properties-wrp">
    <div class="color-item-container" @click="onTogglePopup(true, itemsModified)">
      <div class="item">
        <div
          class="mx-2 item-color"
          :style="{ backgroundColor: itemsModified.color, border: itemsModified.color === '#FFFFFF' ? '1px solid #CCCCCC' : '' }"
        ></div>
        <div>{{ itemsModified.label }}</div>
      </div>
    </div>
    <base-color-picker
      :color-picker-id="`${itemsModified.colorId}`"
      :isAdvance="false"
      :selectedColor="itemsModified.color"
      :is-center="true"
      :initial-position="{ x: 100, y: 100 }"
      :parentElementSelector="'.modal-inner'"
      :isOpen="currentItem === itemsModified"
      @color-picker-close="onTogglePopup(false, itemsModified)"
      @on-color-changed="onClickColor"
    />
  </div>
</template>

<script setup lang="ts">
import useItemProperties from './hooks/useItemProperties';
import BaseColorPicker from '@/views/components/color-picker/BaseColorPicker.vue';

interface Props {
  items: SettingChartModal.ItemProperty;
}

const props = defineProps<Props>();

defineEmits(['on-items-changed', 'color-picker-close', 'on-color-changed']);

const { itemsModified, onClickColor, onTogglePopup, currentItem } = useItemProperties(props);

</script>

<style lang="scss" scoped>
@import '@/assets/styles/modules/analytics/bi/analytics-item-properties.scss';
</style>
